/**
 * Accommodation Component ( NO FILTERS )
 *
 * Dear developer, before you read the below code,
 * please reflect upon all the bad decisions you've
 * ever made in your life.
 * Anyways since you're looking at this ugly code sit back,
 * buckle up and enjoy the ride! :D
 */

// deps
import Fetchling from '~/js/modules/fetchling';
import PropTypes from 'prop-types';
import AccommodationCard from '~/js/components/accommodations/AccommodationCard';
import Modal from '~/js/components/global/Modal';
import FeatureTooltips from '~/js/components/accommodations/FeatureTooltips';
import ReactLoader from '~/js/components/global/ReactLoader';

// internals
const internals = {};
const { Component, Fragment } = React;
const GoFetch = new Fetchling();

internals.roomDetailURI = {
  bcv: '/resorts/turks-caicos/caribbean-village/',
  bfv: '/resorts/turks-caicos/french-village/',
  bit: '/resorts/turks-caicos/italian-village/',
  kwv: '/resorts/turks-caicos/keywest-village/',
  phs: '/resorts/turks-caicos/rooms/penthouse-suites/',
  sbv: '/resorts/turks-caicos/butler-villas/'
};

internals.villas = ['BCV', 'BFV', 'BIT', 'KWV'];

export default class MainPanel extends Component {
  static propTypes = {
    resortCode: PropTypes.string.isRequired,
    villageCode: PropTypes.string,
    accomodationTitle: PropTypes.string,
    filterRoomsArray: PropTypes.array
  };

  static defaultProps = {
    resortCode: '',
    villageCode: '',
    accomodationTitle: '',
    filterRoomsArray: []
  };

  constructor(props) {
    super(props);

    this.state = {
      rooms: [],
      isListView: false,
      modalTitle: '',
      modalDetails: '',
      status: 'loading'
    };
  }

  componentDidMount() {
    const { _updateStatus } = this;
    const { resortCode } = this.props;
    const requestBody = { resortCode };

    GoFetch.post('/fetchRoomData/', null, requestBody)
      .then(response => {
        const { status = 'error', data = {} } = response;

        if (status === 'success' && data.roomData && data.roomData.length > 0) {
          if (this.props.villageCode.length > 0) {
            if (internals.villas.includes(this.props.villageCode)) {
              const rooms = this._filterRoomsBy(response.data.roomData);

              this._updateRooms(rooms, _updateStatus('success'));
            } else {
              const specificRooms = response.data.roomData.filter((room) => this.props.filterRoomsArray.includes(room.code));

              this._updateRooms(specificRooms, _updateStatus('success'));
            }

            return 0;
          }
          this._updateRooms(response.data.roomData, _updateStatus('success'));
        } else {

          _updateStatus('error');
        }

        return 0;
      });

    window.addEventListener('resize', _.debounce(() => {

      if (window.innerWidth < 768 && this.state.isListView) {
        this.setState({ isListView: false });
      }
    }, 200));
  }

  _updateRooms = (rooms, cb) => this.setState({ rooms }, cb);

  _updateStatus = (status) => this.setState({ status });

  _updateModal = (modalTitle = '', modalDetails = '') => () => this.setState({ modalTitle, modalDetails });

  _filterRoomsBy = (rooms = []) => {
    const { villageCode = '' } = this.props;

    return rooms.filter((room) => room.groupCode === villageCode);
  }

  _updateView = (isListView = false) => () => this.setState({ isListView });

  render() {
    const modalId = 'mdl-promotion';
    const { isListView, status } = this.state;
    const { villageCode } = this.props;

    return (
      <Fragment>
        {
          {
            error: (<span className="txt-center display-block">An error has ocurred, please refresh this page and try again</span>),
            loading: (<ReactLoader className="sk-loader-accommodation-level"/>),
            success: (<Fragment>
              <div className="row center-xs">
                <div className="xs-12 txt-left pr">
                  <h3 className={`accommodation-ttl inline-block color-blue ${ internals.villas.includes(villageCode) ? '' : 'no-ttl' }`}>
                    Accommodation
                    <span className={`opensans-semibold uppercase ${(villageCode === 'BCV' ? '' : 'no-pad')}`}>
                      {`at ${this.props.accomodationTitle}`}
                    </span>
                  </h3>
                  <div className="inline-block grid-view txt-center pa hidden-xs">
                    <div onClick={ this._updateView() } className="change-view color-acacac">
                      <i className={`icon-grid-view ${ (!isListView) ? 'color-blue' : '' }`} />
                      <span className="display-block opensans-semibold color-373737">GRID VIEW</span>
                    </div>
                  </div>
                  <div className="inline-block list-view txt-center pa hidden-xs">
                    <div onClick={ this._updateView(true) } className="change-view color-acacac">
                      <i className={`icon-list-view ${ (isListView) ? 'color-blue' : '' }`} />
                      <span className="display-block opensans-semibold color-373737">LIST VIEW</span>
                    </div>
                  </div>
                </div>
                <div className="tooltip_templates hide">
                  <FeatureTooltips />
                </div>
                {
                  this.state.rooms.map((room) => <AccommodationCard key={room.code} roomInformation={room} isListView={this.state.isListView} modalId={modalId} updateModal={this._updateModal} villageCode={this.props.villageCode} roomDetailURI={internals.roomDetailURI} includeResortParam />)
                }
                <Modal id={modalId} title={this.state.modalTitle} content={this.state.modalDetails} />
              </div>
            </Fragment>)
          }[status]
        }
      </Fragment>
    );
  }
}
